import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { useTheme } from '@mui/material/styles';
import { Grid, Container, Typography, Box, CircularProgress, Button, Stack, List, ListItem, ListItemButton, ListItemIcon, ListItemText, TextField } from '@mui/material';
// components
import StarIcon from '@mui/icons-material/Star';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';

// sections
import { DeleteOutline } from '@mui/icons-material';
import { addHousekeepingService, addHousekeepingSubService, addMaintenanceService, addMaintenanceSubService, getSerivces } from '../../api/admin/service';
import CustomSnackBar from '../../components/snackbar';
import FeedbackSectionDialog from '../../sections/dialogs/feedbackSectionDialog';
import FeedbackQuestionDialog from '../../sections/dialogs/feedbackQuestionDialog';
import AddServieceDialog from '../../sections/dialogs/addServiceDialog';
import AddSubServiceDialog from '../../sections/dialogs/addSubServiceDialog';

const getColor = ['secondary', 'info', 'warning', 'error']
// ----------------------------------------------------------------------

export default function ServiceSection() {
  const theme = useTheme();
  const { hospitalAccount } = useSelector((state) => state.account)

  const [isLoading, setIsLoading] = useState(false)

  const [housekeepingService, setHousekeepingService] = useState(false)
  const [houseKeepingSubService, setHouseKeepingSubService] = useState(false)
  const [maintenanceService, setMaintenanceService] = useState(false)
  const [maintenanceSubService, setMaintenanceSubService] = useState(false)
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState(null)
  const [action, setAction] = useState('');
  const [dialogOpen1, setDialogOpen1] = useState(false);
  const [dialogOpen2, setDialogOpen2] = useState(false);
  const [editState, setEditState] = useState(false)
  const [tempValue, setTempValue] = useState(false)
  const [selectedId, setSelectedId] = useState(false)

  // Dialog
  const handleDialogOpen1 = (str) => {
    console.log('am in');
    setAction(str)
    setDialogOpen1(true);
  };

  // Dialog
  const handleDialogOpen2 = (str) => {
    console.log('am here');

    setAction(str)
    setDialogOpen2(true);
  };

  const handleEdit = (id, title, action) => {
    console.log('am here', id);
    setTempValue(title)
    setEditState(true);
    setSelectedId(id)

  };

  const handleEditSubmit = async (id, action) => {
    console.log('am edit here', id);
    let postData = [];
    if (action === 'housekeeping' && housekeepingService.length) {
      postData = housekeepingService.map((item) => { if (item.serviceId === id) { return { ...item, serviceTitle: tempValue } } return item })
    }
    if (action === 'maintenance' && maintenanceService.length) {
      postData = maintenanceService.map((item) => { if (item.serviceId === id) { return { ...item, serviceTitle: tempValue } } return item })
    }
    try {
      const { data } = action === 'housekeeping' ? await addHousekeepingService(hospitalAccount._id, { serviceType: "housekeeping", services: postData }) : await addMaintenanceService(hospitalAccount._id, { serviceType: "maintenance", services: postData })
      if (data.success) {
        if (action === 'housekeeping') {
          setHousekeepingService(data.services.services)
        }
        else {
          setMaintenanceService(data.services.services)
        }
        setEditState(false)
        setSnackbarMessage({ msg: data.message, success: false });
        setSnackbarOpen(true);
      } else {
        setSnackbarMessage({ msg: data.message, success: false });
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage({ msg: error.message, success: false });
      setSnackbarOpen(true);
    }
  };

  const handleDelete = async (id, action) => {
    console.log('am here', id, action);
    let postData = [];
    if (action === 'housekeeping' && housekeepingService.length) {
      postData = housekeepingService.filter((item) => item.serviceId !== id)
    }
    if (action === 'maintenance' && maintenanceService.length) {
      postData = maintenanceService.filter((item) => item.serviceId !== id)
    }

    try {
      const { data } = action === 'housekeeping' ? await addHousekeepingService(hospitalAccount._id, { serviceType: "housekeeping", services: postData }) : await addMaintenanceService(hospitalAccount._id, { serviceType: "maintenance", services: postData })
      if (data.success) {
        if (action === 'housekeeping') {
          setHousekeepingService(data.services.services)
        }
        else {
          setMaintenanceService(data.services.services)
        }
        setSnackbarMessage({ msg: data.message, success: false });
        setSnackbarOpen(true);
      } else {
        setSnackbarMessage({ msg: data.message, success: false });
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage({ msg: error.message, success: false });
      setSnackbarOpen(true);
    }
  };

  const handleSubDelete = async (id, subId, action) => {
    console.log('am here', id, action);
    let postData = [];
    if (action === 'housekeeping' && housekeepingService.length) {
      postData = housekeepingService.find((item) => item.serviceId === id).subServices.filter((it) => it.subServiceId !== subId)

      // postData = housekeepingService.map((item) => { if (item.serviceId === id) { return { ...item, subServices: item.subServices.filter((it) => it.subServiceId !== subId) } } return item })
      console.log({postData});
    }
    if (action === 'maintenance' && maintenanceService.length) {
      postData = maintenanceService.find((item) => item.serviceId === id).subServices.filter((it) => it.subServiceId !== subId)

      // postData = maintenanceService.map((item) => { if (item.serviceId === id) { return { ...item, subServices: item.subServices.filter((it) => it.subServiceId !== subId) } } return item })
    }

    try {
      const { data } = action === 'housekeeping' ? await addHousekeepingSubService(hospitalAccount._id, { serviceId: id, subServices: postData }) : await addMaintenanceSubService(hospitalAccount._id, {serviceId: id, subServices: postData  })
      if (data.success) {
        if( action === 'housekeeping')
        {
          setHousekeepingService(data?.houseKeepingData?.services)
        }
        else{
          setMaintenanceService(data?.maintenanceData?.services)
        }
        setSnackbarMessage({ msg: data.message, success: false });
        setSnackbarOpen(true);
      } else {
        setSnackbarMessage({ msg: data.message, success: false });
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage({ msg: error.message, success: false });
      setSnackbarOpen(true);
    }
  };


  const fetchData = async () => {
    setIsLoading(true)
    try {
      const { data } = await getSerivces(hospitalAccount._id);
      if (data.success) {
        console.log({ data });
        if (data.housekeeping) {
          setHousekeepingService(data.housekeeping.services)
        }
        if (data.maintenance) {
          setMaintenanceService(data.maintenance.services)
        }

      }

      console.log('data1', data);

      setIsLoading(false)
    }
    catch (e) {
      setIsLoading(false)
      // console.log({ e });
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Helmet>
        <title> Service | Teller One </title>
      </Helmet>
      <Box sx={{ height: '100%' }}>
        {!isLoading ?
          <>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
              <Typography variant="h4" gutterBottom>
                Housekeeping Services
              </Typography>
              <Button variant="contained" onClick={() => handleDialogOpen1('housekeeping')}>
                Add Houskeeping Service
              </Button>
              {housekeepingService && housekeepingService.length !== 0 &&
                <Button variant="contained" onClick={() => handleDialogOpen2('housekeeping')}>
                  Add Houskeeping Sub Service
                </Button>}
            </Stack>

            <List
              sx={{ width: '100%', maxWidth: 660, bgcolor: 'background.paper' }}
              aria-label="contacts"
            >
              {housekeepingService.length ? housekeepingService.map((item) =>
                <ListItem disablePadding key={item.serviceId}>
                  <Stack>
                    <Box display='flex' justifyContent='space-between' >

                      <Box display='flex' width={380}>
                        <ListItemIcon>
                          <StarIcon />
                        </ListItemIcon>
                        {(editState && selectedId === item.serviceId) ? <Box><TextField value={tempValue} onChange={(e) => setTempValue(e.target.value)} /> <Button onClick={() => handleEditSubmit(item.serviceId, 'housekeeping')}>Submit</Button></Box>
                          :
                          <ListItemText primary={item.serviceTitle} />}
                      </Box>
                      <Box display='flex'>
                        <ListItemIcon sx={{ cursor: 'pointer' }} onClick={() => handleEdit(item.serviceId, item.serviceTitle, 'housekeeping')}>
                          <EditIcon />
                        </ListItemIcon>
                        <ListItemIcon sx={{ cursor: 'pointer' }} onClick={() => handleDelete(item.serviceId, 'housekeeping')}>
                          <DeleteIcon />
                        </ListItemIcon>
                      </Box>


                    </Box>
                    <Box>
                      {item.subServices.map((it) =>
                        <Box display='flex' alignItems='center' justifyContent='space-between' width={100} ml={6}>
                          <Typography fontSize={14} >   {it.subServiceTitle} </Typography>
                          <CloseIcon fontSize='10px' sx={{cursor:'pointer'}} onClick={() => handleSubDelete(item.serviceId, it.subServiceId, 'housekeeping')}/>
                        </Box>

                      )}

                    </Box>
                  </Stack>
                </ListItem>

              ) : <Typography>No Item</Typography>}

            </List>

            {/* <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
              <Typography variant="h4" gutterBottom>
                Housekeeping Sub Services
              </Typography>
              <Button variant="contained" onClick={() => handleDialogOpen2('housekeeping')}>
                Add Houskeeping Sub Service
              </Button>
            </Stack>
            
            <List
              sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
              aria-label="contacts"
            >
              { housekeepingService.map((item) => 
              <ListItem disablePadding key={item.serviceId}>
                
                  <ListItemIcon>
                    <StarIcon />
                  </ListItemIcon>
                  <ListItemText primary={item.serviceTitle} />
                
              </ListItem>
             )}
             
            </List>
             */}

            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
              <Typography variant="h4" gutterBottom>
                Maintenance Services
              </Typography>
              <Button variant="contained" onClick={() => handleDialogOpen1('maintenance')}>
                Add Maintenance Service
              </Button>
              {maintenanceService && maintenanceService.length !== 0 &&
                <Button variant="contained" onClick={() => handleDialogOpen2('maintenance')}>
                  Add Maintenance Sub Service
                </Button>}
            </Stack>
            <List
              sx={{ width: '100%', maxWidth: 560, bgcolor: 'background.paper' }}
              aria-label="contacts"
            >
              {maintenanceService ? maintenanceService.map((item) =>
                <ListItem disablePadding key={item.serviceId}>
                  <Stack>
                    <Box display='flex' justifyContent='space-between' >
                      <Box display='flex' width={380}>
                        <ListItemIcon>
                          <StarIcon />
                        </ListItemIcon>
                        {(editState && selectedId === item.serviceId) ? <Box><TextField value={tempValue} onChange={(e) => setTempValue(e.target.value)} /> <Button onClick={() => handleEditSubmit(item.serviceId, 'maintenance')}>Submit</Button></Box>
                          :
                          <ListItemText primary={item.serviceTitle} />}
                      </Box>
                      <Box display='flex'>
                        <ListItemIcon sx={{ cursor: 'pointer' }} onClick={() => handleEdit(item.serviceId, item.serviceTitle, 'maintenance')}>
                          <EditIcon />
                        </ListItemIcon>
                        <ListItemIcon sx={{ cursor: 'pointer' }} onClick={() => handleDelete(item.serviceId, 'maintenance')}>
                          <DeleteIcon />
                        </ListItemIcon>
                      </Box>
                    </Box>
                    <Box>
                      {item.subServices.map((it) =>
                        <Box display='flex' alignItems='center' justifyContent='space-between' width={100} ml={6}>
                        <Typography fontSize={14} >   {it.subServiceTitle} </Typography>
                        <CloseIcon fontSize='10px' sx={{cursor:'pointer'}} onClick={() => handleSubDelete(item.serviceId, it.subServiceId, 'maintenance')}/>
                      </Box>
                      )}
                    </Box>
                  </Stack>
                </ListItem>
              ) : <Typography>No Item</Typography>}
            </List>

            {/* <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
              <Typography variant="h4" gutterBottom>
                Maintenance Sub Services
              </Typography>
              <Button variant="contained" onClick={() => handleDialogOpen2('maintenance')}>
                Add Maintenance Sub Service
              </Button>
            </Stack>
            <List
              sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
              aria-label="contacts"
            >
              { maintenanceService.map((item) => 
              <ListItem disablePadding key={item.serviceId}>
                <ListItemIcon>
                    <StarIcon />
                  </ListItemIcon>
                <Typography>{item.serviceTitle}</Typography>
              </ListItem>
             )}
              </List> */}
          </>
          :
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}><CircularProgress /></Box>}
      </Box>

      <AddServieceDialog dialogOpen={dialogOpen1} setDialogOpen={setDialogOpen1} setSnackbarMessage={setSnackbarMessage} setSnackbarOpen={setSnackbarOpen} action={action} setHousekeepingService={setHousekeepingService} setMaintenanceService={setMaintenanceService} housekeepingService={housekeepingService} maintenanceService={maintenanceService} />
      {dialogOpen2 && <AddSubServiceDialog dialogOpen={dialogOpen2} setDialogOpen={setDialogOpen2} setSnackbarMessage={setSnackbarMessage} setSnackbarOpen={setSnackbarOpen} housekeepingService={housekeepingService} maintenanceService={maintenanceService} action={action} setHousekeepingService={setHousekeepingService} setMaintenanceService={setMaintenanceService} />}
      <CustomSnackBar snackbarOpen={snackbarOpen} setSnackbarOpen={setSnackbarOpen} snackbarMessage={snackbarMessage && snackbarMessage.msg} success={snackbarMessage && snackbarMessage.success} />

    </>
  );
}
